"use client";
import React from "react";
import Card from "../ui/Card";
import Link from "next/link";

function HowItWorksReferral({ showCard = true }) {
  return (
    <Card
      className={` p-6 w-full text-left ${ 
        showCard ? "bg-gray-50 shadow-md rounded-lg " : ""
      }`}
      noborder={!showCard}
    >
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        How It Works
      </h2>
      <ol className="list-decimal list-inside text-gray-700 space-y-3">
        <li>
          <Link href={"/register"}>
            <strong>Sign Up:</strong>
          </Link>{" "}
          Create a free account.
        </li>
        <li>
          <strong>Spread the Word:</strong> Share your referral link via email,
          social media, or directly with potential clients.
        </li>
        <li>
          <strong>Earn Big:</strong> Earn up to{" "}
          <span className="text-blue-500 font-bold">Real money</span> for every
          successful referral who completes their verification with us.
        </li>
      </ol>
    </Card>
  );
}

export default HowItWorksReferral;
